export default __webpack_public_path__ + "static/media/room-propolis-main.0a5455a9.webp";